<template>
  <div v-if="show">
    <div class="dialog-add-account__form-title">
      {{ $t('business_account_data.id_prefix') }}
    </div>
    <div class="dialog-add-account__form-block">
      <div class="dialog-add-account__form-row">
        <div class="dialog-add-account__form-col dialog-add-account__form-col--big">
          <div class="dialog-add-account__form-item">
            <div class="form-input" :class="[{ 'form-input--full': value }]">
              <input
                :value="value"
                type="text"
                :disabled="disabled"
                @input="$emit('input', $event.target.value)"
              />
              <span class="form-input__label">
                {{ $t('business_account_data.input_prefix') }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'IdPrefixInput',
  props: {
    value: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    show: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['input'],
};
</script>
